import { api } from "./api";

const categoryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getWarehouse: builder.query({
      query: () => "/warehouses",
      providesTags: ["warehouses"],
    }),
    addWarehouse: builder.mutation({
      query: (newCategory) => ({
        url: "/warehouses",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["warehouses"],
    }),
    removeWarehouse: builder.mutation({
      query: (id) => ({
        url: `/warehouses/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["warehouses"],
    }),
    editWarehouse: builder.mutation({
      query: ({ id, ...editData }) => ({
        url: `/warehouses/${id}`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["warehouses"],
    }),
  }),
});

export const {
  useGetWarehouseQuery,
  useAddWarehouseMutation,
  useRemoveWarehouseMutation,
  useEditWarehouseMutation,
} = categoryApi;
